<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headersFiltered"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.name="{ header, item, value: v }">
      <router-link
        v-if="header.getRoute"
        :to="header.getRoute(item)"
        v-text="v"
      />
      <template v-else>
        {{ v }}
      </template>
    </template>

    <template #item.ates="{ value: v }">
      <BTableItemAte v-if="v" :data="v" />
    </template>

    <template v-for="(_, key) in $scopedSlots" #[key]="props">
      <slot v-bind="props" :name="key" />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import BTable from '@/components/common/BTable.vue'
import BTableItemAte from './components/BTableItemAte.vue'


export default {
  name: 'BTableSimple',
  components: {
    BTable,
    BTableItemAte,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    headers: {
      type: Array,
      required: true,
    },
    actions: {
      type: Array,
      required: true,
    },
    list: {
      type: Array,
    },
  },
  computed: {
    headersFiltered() {
      return this.headers
    },
  },
}
</script>
